// Whether this page is the page editor's canvas. Every page that can be a
// canvas loads this, so it stays dependency-free; the editor messaging itself
// is only loaded when this says yes (see usePortalsEditorCanvas).

/**
 * Query param the host adds to the canvas URL so the portal app can tell the
 * page editor apart from other preview hosts (e.g. the theme previewer), which
 * load the same `/hs/portals/preview` route.
 */
export const EDITOR_CANVAS_QUERY_PARAM = 'portalsEditorCanvas';

// Origins allowed to host the page editor: HubSpot app domains (any hublet)
// and local dev, with or without a workspace prefix.
const EDITOR_HOST_ORIGIN = /^https:\/\/(app(-[a-z0-9]+)?\.hubspot(qa)?\.com|([a-z0-9-]+\.)?local\.hubspot(qa)?\.com)$/;
export function isAllowedEditorHost(origin) {
  return EDITOR_HOST_ORIGIN.test(origin);
}
/**
 * The page editor host's origin, when this page is its canvas: framed, opened
 * in preview mode with the editor flag, by an allowed origin. The candidate
 * comes from `ancestorOrigins` (the referrer where that's unsupported) and is
 * only trusted if it's on the allowlist.
 */
export function detectEditorHostOrigin({
  search,
  isFramed,
  ancestorOrigin,
  referrer
}) {
  const params = new URLSearchParams(search);
  if (!isFramed || params.get('isPortalPreview') !== 'true' || params.get(EDITOR_CANVAS_QUERY_PARAM) !== 'true') {
    return undefined;
  }
  let candidate = ancestorOrigin;
  if (!candidate && referrer) {
    try {
      candidate = new URL(referrer).origin;
    } catch (_unused) {
      candidate = undefined;
    }
  }
  return candidate && isAllowedEditorHost(candidate) ? candidate : undefined;
}
let checked = false;
let editorHostOrigin;

/** This page's editor host origin, when it's the editor's canvas. */
export function getEditorHostOrigin() {
  if (!checked && typeof window !== 'undefined') {
    var _window$location$ance;
    checked = true;
    editorHostOrigin = detectEditorHostOrigin({
      search: window.location.search,
      isFramed: window.parent !== window,
      ancestorOrigin: // Firefox lacks it; detectEditorHostOrigin falls back to the referrer.
      // eslint-disable-next-line compat/compat
      (_window$location$ance = window.location.ancestorOrigins) === null || _window$location$ance === void 0 ? void 0 : _window$location$ance[0],
      referrer: document.referrer
    });
  }
  return editorHostOrigin;
}